import { useState } from "react";
import LocalisationMisService from "../services/LocalisationMisService";

export const useLocalisation = () => {
  const [regionsDepart, setRegionsDepart] = useState([]);
  const [regionsArrivee, setRegionsArrivee] = useState([]);

  const [districtsDepart, setDistrictsDepart] = useState({});
  const [districtsArrivee, setDistrictsArrivee] = useState({});

  const [communesDepart, setCommunesDepart] = useState({});
  const [communesArrivee, setCommunesArrivee] = useState({});

  const [fokontanyDepart, setFokontanyDepart] = useState({});
  const [fokontanyArrivee, setFokontanyArrivee] = useState({});

  const fetchRegions = async () => {
    if (regionsDepart.length && regionsArrivee.length) {
      return regionsDepart;
    }
    try {
      const result = await LocalisationMisService.getRegions();
      if (result?.status) {
        setRegionsDepart(result.data);
        setRegionsArrivee(result.data);
        return result.data;
      }
    } catch (error) {
      console.error("Error fetching regions:", error);
    }
    return [];
  };

  const fetchDistrictsByRegion = async (regionId, type = "depart") => {
    if (!regionId) {
      return [];
    }
    const cache = type === "depart" ? districtsDepart : districtsArrivee;
    if (cache[regionId]) {
      return cache[regionId];
    }
    try {
      const result = await LocalisationMisService.getDistrictByRegion(regionId);
      if (result?.status) {
        const setter = type === "depart" ? setDistrictsDepart : setDistrictsArrivee;
        setter((prev) => ({ ...prev, [regionId]: result.data }));
        return result.data;
      }
    } catch (error) {
      console.error("Error fetching districts:", error);
    }
    return [];
  };

  const fetchCommunesByDistrict = async (districtId, type = "depart") => {
    if (!districtId) {
      return [];
    }
    const cache = type === "depart" ? communesDepart : communesArrivee;
    if (cache[districtId]) {
      return cache[districtId];
    }
    try {
      const result = await LocalisationMisService.getCommunesByDistrict(districtId);
      if (result?.status) {
        const setter = type === "depart" ? setCommunesDepart : setCommunesArrivee;
        setter((prev) => ({ ...prev, [districtId]: result.data }));
        return result.data;
      }
    } catch (error) {
      console.error("Error fetching communes:", error);
    }
    return [];
  };

  const fetchFokontanyByCommune = async (communeId, type = "depart") => {
    if (!communeId) {
      return [];
    }
    const cache = type === "depart" ? fokontanyDepart : fokontanyArrivee;
    if (cache[communeId]) {
      return cache[communeId];
    }
    try {
      const result = await LocalisationMisService.getFokontantByCommune(communeId);
      if (result?.status) {
        const setter = type === "depart" ? setFokontanyDepart : setFokontanyArrivee;
        setter((prev) => ({ ...prev, [communeId]: result.data }));
        return result.data;
      }
    } catch (error) {
      console.error("Error fetching fokontany:", error);
    }
    return [];
  };

  return {
    regionsDepart,
    regionsArrivee,
    districtsDepart,
    districtsArrivee,
    communesDepart,
    communesArrivee,
    fokontanyDepart,
    fokontanyArrivee,
    fetchRegions,
    fetchDistrictsByRegion,
    fetchCommunesByDistrict,
    fetchFokontanyByCommune,
  };
};
